export default [
  {
    path: "/dashboard",
    name: "dashboard",
    redirect: "/dashboard/index",
    meta: { title: "看板" },
    component: () => import("@/layouts/PageLayouts.vue"),
    children: [
      {
        path: "/dashboard/index",
        name: "dashboard-index",
        component: () => import("@/views/dashboard/operation-dashboard/home"),
        meta: { title: "运营看板" },
      },
    
            {
        path: "/dashboard/configPage",
        name: "dashboard-configPage",
        component: () => import("@/views/setting/configPage.vue"),
        meta: { title: "智能体配置" },
      },
      {
        path: "/dashboard/userinfo",
        name: "operation-dashboard-userinfo",
        component: () =>
          import("@/views/dashboard/operation-dashboard/user-info-detail"),
        meta: { title: "用户数据详情" },
      },
      {
        path: "/dashboard/aiinfo",
        name: "operation-dashboard-aiinfo",
        component: () =>
          import("@/views/dashboard/operation-dashboard/ai-info-detail"),
        meta: { title: "AI使用数据详情" },
      },
      {
        path: "/dashboard/visitinfo",
        name: "operation-dashboard-visitinfo",
        component: () =>
          import("@/views/dashboard/operation-dashboard/visit-info-detail"),
        meta: { title: "模块访问数据详情" },
      },
      {
        path: "/dashboard/active-code",
        name: "dashboard-active-code",
        component: () => import("@/views/dashboard/active-code/index.vue"),
        meta: { title: "激活码管理" },
      },
    ],
  },
];